export default __webpack_public_path__ + "static/media/ActSciMafi_2021_RiskSensitiveRL.1ccdd36f.pdf";